export const login_tr = {
  title: 'Giriş',
  tr: "Türkçe",
  en: "İngilizce",

  login: "Giriş",
  username: "Kullanıcı adı",
  password: "Parola"
};
